<template>
  <div class="max-w-full mx-auto p-4 sm:p-6 lg:p-8 text-[#1a1a1a]">
    <!-- Header -->
          <!-- Header -->
    <div class="flex justify-between items-center border-b border-gray-200 py-4 mb-6">
      <h1 class="text-lg font-normal">Newsletter</h1>
      
    </div>

    <!-- Actions -->
    <div class="flex flex-row sm:items-center sm:space-x-2 mb-4">
      <button
        @click="exportSelected"
        class="flex items-center gap-2 border border-gray-300 text-sm font-semibold rounded-md px-4 py-2 hover:bg-gray-100"
      >
        <i class="fas fa-download"></i>
        Export Selected
      </button>
      <button
        @click="exportAllSubscribers"
        class="flex items-center gap-2 border border-gray-300 text-sm font-semibold rounded-md px-4 py-2 hover:bg-gray-100"
      >
        <i class="fas fa-download"></i>
        Export All Subscribers
      </button>
    </div>

    <!-- Table -->
    <div class="overflow-x-auto rounded-lg border border-gray-200 bg-white">
      <table class="min-w-full divide-y divide-gray-200 text-sm">
        <thead class="bg-[#f9f9f9]">
          <tr>
            <th class="w-12 px-4 py-3 text-left text-gray-400 font-semibold">
              <input aria-label="Select all" type="checkbox" v-model="selectAll" @change="toggleAll"/>
            </th>
            <th class="px-4 py-3 text-left text-gray-400 font-semibold">Nom</th>
            <th class="px-4 py-3 text-left text-gray-400 font-semibold">Email</th>
            <th class="px-4 py-3 text-left text-gray-400 font-semibold">Date de souscription</th>
            <th class="px-4 py-3 text-left text-gray-400 font-semibold">Exporté</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200">
          <tr v-for="(lead, index) in filteredLeads" :key="index" :class="hoverClasses[index % hoverClasses.length]">
            <td class="px-4 py-3">
              <input type="checkbox" v-model="lead.selected"/>
            </td>
            <td class="px-4 py-3 whitespace-nowrap">{{ lead.nom }}</td>
            <td class="px-4 py-3 whitespace-nowrap">{{ lead.email }}</td>
            <td class="px-4 py-3 whitespace-nowrap">{{ lead.dateSouscription }}</td>
            <td class="px-4 py-3 whitespace-nowrap">
              <span v-if="lead.exported" class="text-green-500 font-semibold">Oui</span>
              <span v-else class="text-red-500 font-semibold">Non</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchQuery: "",
      selectAll: false,
      hoverClasses: ["hover:bg-[#fef6e7]", "hover:bg-[#d9f0fb]", "hover:bg-[#f9d6d6]", "hover:bg-[#e2e2e2]"],
      leads: [
        { nom: "David", email: "david.k@mlion.com", dateSouscription: "2025-08-01", exported: false, selected: false },
        { nom: "Alice", email: "alice.k@mlion.com", dateSouscription: "2025-08-03", exported: true, selected: false },
        { nom: "Bob", email: "bob.k@mlion.com", dateSouscription: "2025-08-05", exported: false, selected: false },
      ]
    };
  },
  computed: {
    filteredLeads() {
      if (!this.searchQuery) return this.leads;
      const q = this.searchQuery.toLowerCase();
      return this.leads.filter(l =>
        l.nom.toLowerCase().includes(q) ||
        l.email.toLowerCase().includes(q)
      );
    }
  },
  methods: {
    toggleAll() {
      this.leads.forEach(lead => (lead.selected = this.selectAll));
    },
    exportSelected() {
      const dataToExport = this.leads
        .filter(l => l.selected)
        .map(l => [l.nom, l.email, l.dateSouscription, l.exported ? "Oui" : "Non"]);
      this.downloadCSV(dataToExport);
      this.markAsExported(dataToExport);
    },
    exportAllSubscribers() {
      const dataToExport = this.leads.map(l => [l.nom, l.email, l.dateSouscription, l.exported ? "Oui" : "Non"]);
      this.downloadCSV(dataToExport);
      this.markAsExported(dataToExport);
    },
    downloadCSV(data) {
      if (!data.length) {
        alert("No data to export!");
        return;
      }
      const csvContent = "data:text/csv;charset=utf-8," +
        ["Nom,Email,Date de souscription,Exporté", ...data.map(d => d.join(","))].join("\n");
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "leads.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    markAsExported(data) {
      data.forEach(d => {
        const lead = this.leads.find(l => l.email === d[1]);
        if (lead) lead.exported = true;
      });
    }
  }
};
</script>
